export default __webpack_public_path__ + "static/media/logo-large.a66c877e.png";